import { render, staticRenderFns } from "./TrainingRequestForm.vue?vue&type=template&id=6fbf9ac4"
import script from "./TrainingRequestForm.vue?vue&type=script&lang=js"
export * from "./TrainingRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports